import { Routes } from '@angular/router';
import { CanDeactivateGuard } from './components/shared/can-deactivate-guard.service';
import { AmAuthGuard } from './tools/access-control/am-auth.guard';
import { QmAuthGuard } from './tools/access-control/qm-auth.guard';
import { HomeRedirectGuard } from './tools/home-redirect.guard';
import { RethinkingInsuranceGuard } from './tools/rethinking-insurance.guard';
import { LoginAuthGuard } from './tools/access-control/login-auth.guard';
import { PaAuthGuard } from './tools/access-control/pa-auth.guard';
import { BmAuthGuard } from './tools/access-control/bm-auth.guard';
import { KmAuthGuard } from './tools/access-control/km-auth.guard';
import { KmAccessDeniedGuard } from './tools/access-control/km-access-denied.guard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  // for all public page
  {
    path: '',
    loadComponent: () => import('./public.page.component').then((m) => m.PublicPageComponent),
    children: [
      {
        path: 'home',
        loadComponent: () => import('./components/home/home.component').then((m) => m.HomeComponent),
        canActivate: [HomeRedirectGuard],
      },
      {
        path: 'km/home',
        loadComponent: () =>
          import('./components/home/kiwimonster-home/kiwimonster-home.component').then((m) => m.KiwiMonsterHomeComponent),
      },
      {
        path: 'bm/home',
        loadComponent: () =>
          import('./components/home/businessmonster-home/businessmonster-home.component').then((m) => m.BusinessMonsterHomeComponent),
      },
      {
        path: 'am/home',
        loadComponent: () =>
          import('./components/home/advicemonster-home/advicemonster-home.component').then((m) => m.AdviceMonsterHomeComponent),
      },
      {
        path: 'pricing',
        loadComponent: () => import('./components/shared/pricing/pricing.component').then((m) => m.PricingComponent),
      },
      {
        path: 'login',
        loadComponent: () => import('./components/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'palogin',
        loadComponent: () => import('./components/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'signup',
        loadComponent: () => import('./components/login/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: 'signup/student',
        loadComponent: () => import('./components/login/signup.component').then((m) => m.SignupComponent),
      },
      {
        path: 'mfa-methods-select',
        loadComponent: () =>
          import('./components/login/mfa-method-select/mfa-method-select.component').then((m) => m.MfaMethodSelectComponent),
      },
      {
        path: 'verify-device',
        loadComponent: () => import('./components/login/verify-device.component').then((m) => m.VerifyDeviceComponent),
      },
      {
        path: 'resetpassword',
        loadComponent: () => import('./components/login/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'pa/resetpassword',
        loadComponent: () => import('./components/login/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'updatePaDetail',
        loadComponent: () => import('./components/login/update-pa-password.component').then((m) => m.UpdatePaPasswordComponent),
      },
      {
        path: 'public/about-overview',
        loadComponent: () => import('./components/about/about-overview.component').then((m) => m.AboutOverviewComponent),
      },
      {
        path: 'calls',
        loadComponent: () => import('./components/about/our-calls.component').then((m) => m.OurCallsComponent),
      },
      {
        path: 'trust-marks',
        loadComponent: () => import('./components/about/trust-marks.component').then((m) => m.TrustMarksComponent),
      },
      {
        path: 'public/accuracy',
        loadComponent: () => import('./components/about/accuracy.component').then((m) => m.AccuracyComponent),
      },
      {
        path: 'public/our-independence',
        loadComponent: () => import('./components/about/independence.component').then((m) => m.IndependenceComponent),
      },
      {
        path: 'public/rethinking-insurance',
        loadComponent: () => import('./components/about/rethinking-insurance.component').then((m) => m.RethinkingInsuranceComponent),
        canActivate: [RethinkingInsuranceGuard],
      },
      {
        path: 'public/about-using-quotemonster',
        loadComponent: () => import('./components/about/about-using-quotemonster.component').then((m) => m.AboutUsingQuotemonsterComponent),
      },
      {
        path: 'public/about-faqs',
        loadComponent: () => import('./components/about/about-faqs.component').then((m) => m.AboutFaqsComponent),
      },
      {
        path: 'public/contact',
        loadComponent: () => import('./components/contact/contact.component').then((m) => m.ContactComponent),
      },
      {
        path: 'research/subscription/complete-payment',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-completePayment.component').then(
            (m) => m.ResearchSubscriptionCompletePaymentComponent
          ),
      },
      {
        path: 'public/cpd',
        loadComponent: () =>
          import('./components/research/tools/cpd-training-request-component/cpd-training-request-component.component').then(
            (m) => m.CpdTrainingRequestComponent
          ),
      },
      {
        path: 'public/clientfactfind',
        loadComponent: () =>
          import('./components/fact-find/fact-find-public/fact-find-public.component').then((m) => m.FactFindPublicComponent),
      },
      {
        path: 'public/fact-find-details',
        loadComponent: () =>
          import('./components/fact-find/fact-find-details/fact-find-details.component').then((m) => m.FactFindDetailsComponent),
      },
      {
        path: 'oauth',
        loadComponent: () =>
          import('./components/third-party-company/oauth-login/oauth-login.component').then((m) => m.OauthLoginComponent),
      },
      {
        path: 'tup/oneclicklogin',
        loadComponent: () =>
          import('./components/third-party-company/one-click-login/one-click-login.component').then((m) => m.OneClickLoginComponent),
      },
    ],
  },

  // for all private page
  {
    path: '',
    loadComponent: () => import('./private.page.component').then((m) => m.PrivatePageComponent),
    canActivate: [LoginAuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'dashboard-archives',
        loadComponent: () => import('./components/dashboard/dashboard-archives.component').then((m) => m.DashboardArchivesComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'public/notice',
        loadComponent: () => import('./components/notice/notice.component').then((m) => m.NoticeComponent),
      },
      // quote
      {
        path: 'quote/client',
        loadComponent: () => import('./components/quote/quote-client.component').then((m) => m.QuoteClientComponent),
      },
      {
        path: 'quote/personal/benefit',
        loadComponent: () => import('./components/quote/quote-p-benefit.component').then((m) => m.QuotePersonalBenefitComponent),
      },
      {
        path: 'quote/compare',
        loadComponent: () => import('./components/quote/quote-compare.component').then((m) => m.QuoteCompareComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote/checkmonster',
        loadComponent: () => import('./components/quote/quote-checkmonster.component').then((m) => m.QuoteCheckmonsterComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote/report',
        loadComponent: () => import('./components/quote/quote-report.component').then((m) => m.QuoteReportComponent),
        canActivate: [QmAuthGuard],
      },
      // quote wizard
      {
        path: 'quote-wizard/client-overview',
        loadComponent: () =>
          import('./components/quote/quote-wizard/quote-wizard-client-overview.component').then(
            (m) => m.QuoteWizardClientOverviewComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/client-details',
        loadComponent: () => import('./components/quote/quote-client.component').then((m) => m.QuoteClientComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/suggestion',
        loadComponent: () =>
          import('./components/quote/quote-wizard/quote-wizard-suggestion/quote-wizard-suggestion.component').then(
            (m) => m.QuoteWizardSuggestionComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/personal/benefit',
        loadComponent: () => import('./components/quote/quote-p-benefit.component').then((m) => m.QuotePersonalBenefitComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/checkmonster',
        loadComponent: () => import('./components/quote/quote-checkmonster.component').then((m) => m.QuoteCheckmonsterComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/compare',
        loadComponent: () => import('./components/quote/quote-compare.component').then((m) => m.QuoteCompareComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'quote-wizard/report',
        loadComponent: () => import('./components/quote/quote-report.component').then((m) => m.QuoteReportComponent),
        canActivate: [QmAuthGuard],
      },
      // policy-based quote
      {
        path: 'policy-based/upload-file',
        loadComponent: () => import('./components/quote/policy-based-quote/upload-policy.component').then((m) => m.UploadPolicyComponent),
        canActivate: [AmAuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'policy-based/summary',
        loadComponent: () => import('./components/quote/policy-based-quote/policy-summary.component').then((m) => m.PolicySummaryComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'policy-based/client',
        loadComponent: () => import('./components/quote/quote-client.component').then((m) => m.QuoteClientComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'policy-based/personal/benefit',
        loadComponent: () => import('./components/quote/quote-p-benefit.component').then((m) => m.QuotePersonalBenefitComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'policy-based/checkmonster',
        loadComponent: () => import('./components/quote/quote-checkmonster.component').then((m) => m.QuoteCheckmonsterComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'policy-based/compare',
        loadComponent: () => import('./components/quote/quote-compare.component').then((m) => m.QuoteCompareComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'policy-based/report',
        loadComponent: () => import('./components/quote/quote-report.component').then((m) => m.QuoteReportComponent),
        canActivate: [AmAuthGuard],
      },
      // need analysis
      {
        path: 'needanalysis/nature',
        loadComponent: () => import('./components/need-analysis/need-analysis-nature.component').then((m) => m.NeedAnalysisNatureComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/scope',
        loadComponent: () => import('./components/need-analysis/need-analysis-scope.component').then((m) => m.NeedAnalysisScopeComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/objectives',
        loadComponent: () =>
          import('./components/need-analysis/need-analysis-objectives.component').then((m) => m.NeedAnalysisObjectivesComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/existing',
        loadComponent: () =>
          import('./components/need-analysis/need-analysis-existing.component').then((m) => m.NeedAnalysisExistingComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/financial',
        loadComponent: () =>
          import('./components/need-analysis/need-analysis-financial.component').then((m) => m.NeedAnalysisFinancialComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/calculations',
        loadComponent: () =>
          import('./components/need-analysis/need-analysis-need-cal.component').then((m) => m.NeedAnalysisNeedCalComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'needanalysis/recommendationnotepad',
        loadComponent: () =>
          import('./components/need-analysis/need-analysis-recommendation.component').then((m) => m.NeedAnalysisRecommendationComponent),
        canActivate: [AmAuthGuard],
      },

      // setting
      {
        path: 'setting/quote',
        loadComponent: () => import('./components/setting/quote-setting.component').then((m) => m.QuoteSettingComponent),
      },
      {
        path: 'setting/user',
        loadComponent: () => import('./components/setting/user-setting.component').then((m) => m.UserSettingComponent),
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'setting/commission',
        loadComponent: () => import('./components/setting/commission-setting.component').then((m) => m.CommissionSettingComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'setting/occupation',
        loadComponent: () => import('./components/setting/occupation-setting.component').then((m) => m.OccupationSettingComponent),
      },
      {
        path: 'setting/need',
        loadComponent: () => import('./components/setting/need-setting.component').then((m) => m.NeedSettingComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'setting/buy-now',
        loadComponent: () => import('./components/setting/buy-now-setting.component').then((m) => m.BuyNowSettingComponent),
      },
      {
        path: 'setting/crm',
        loadComponent: () => import('./components/setting/crm-setting.component').then((m) => m.CrmSettingComponent),
      },
      {
        path: 'setting/soa',
        loadComponent: () => import('./components/setting/soa-setting.component').then((m) => m.SoaSettingComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'setting/security',
        loadComponent: () => import('./components/setting/security-setting.component').then((m) => m.SecuritySettingComponent),
      },
      {
        path: 'setting/admin-compliance',
        loadComponent: () =>
          import('./components/setting/admin-compliance-setting/admin-compliance-setting.component').then(
            (m) => m.AdminComplianceSettingComponent
          ),
        canActivate: [PaAuthGuard],
      },
      {
        path: 'setting/pa-security',
        loadComponent: () => import('./components/setting/security-setting.component').then((m) => m.SecuritySettingComponent),
        canActivate: [PaAuthGuard],
      },
      {
        path: 'setting/main',
        loadComponent: () => import('./components/setting/main-setting.component').then((m) => m.MainSettingComponent),
      },
      {
        path: 'setting/user-profile',
        loadComponent: () => import('./components/setting/user-profile.component').then((m) => m.UserProfileComponent),
      },
      {
        path: 'setting/research',
        loadComponent: () => import('./components/setting/research-setting.component').then((m) => m.ResearchSettingComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'business/setting/quote',
        loadComponent: () =>
          import('./components/setting/business/business-quote-setting/business-quote-setting.component').then(
            (m) => m.BusinessQuoteSettingComponent
          ),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/setting/soa',
        loadComponent: () =>
          import('./components/setting/business/business-soa-setting/business-soa-setting.component').then(
            (m) => m.BusinessSoaSettingComponent
          ),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'setting/platform',
        loadComponent: () =>
          import('./components/setting/platform-setting/platform-setting.component').then((m) => m.PlatformSettingComponent),
      },
      // research
      {
        path: 'research/home/overview',
        loadComponent: () => import('./components/research/home/research-home.component').then((m) => m.ResearchHomeComponent),
      },
      {
        path: 'research/home/our-approach',
        loadComponent: () =>
          import('./components/research/home/research-home.ourApproach.component').then((m) => m.ResearchHomeOurApproachComponent),
      },
      {
        path: 'research/home/features',
        loadComponent: () =>
          import('./components/research/home/research-home.features.component').then((m) => m.ResearchHomeFeaturesComponent),
      },
      {
        path: 'research/home/methodology',
        loadComponent: () =>
          import('./components/research/home/research-home.methodology.component').then((m) => m.ResearchHomeMethodologyComponent),
      },
      {
        path: 'research/home/faqs',
        loadComponent: () => import('./components/research/home/research-home.faqs.component').then((m) => m.ResearchHomeFaqsComponent),
      },
      {
        path: 'research/home/advertising',
        loadComponent: () =>
          import('./components/research/home/research-home.advertising.component').then((m) => m.ResearchHomeAdvertisingComponent),
      },
      {
        path: 'research/home/infographics',
        loadComponent: () =>
          import('./components/research/home/research-home.infographics.component').then((m) => m.ResearchHomeInfographicsComponent),
      },
      {
        path: 'research/tools/independent-research',
        loadComponent: () =>
          import('./components/research/tools/research-tools.independentResearch.component').then(
            (m) => m.ResearchToolsIndependentResearchComponent
          ),
      },
      {
        path: 'research/tools/funeral-plans',
        loadComponent: () =>
          import('./components/research/tools/research-tools.funeralPlans.component').then((m) => m.ResearchToolsFuneralPlansComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/tools/business-overheads-cover',
        loadComponent: () =>
          import('./components/research/tools/research-tools.businessOverheadsCover.component').then(
            (m) => m.ResearchToolsBusinessOverheadsCoverComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/tools/disability-claims-model',
        loadComponent: () =>
          import('./components/research/tools/research-tools.disabilityClaimsModel.component').then(
            (m) => m.ResearchToolsDisabilityClaimsModelComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/tools/key-person-rating',
        loadComponent: () =>
          import('./components/research/tools/research-tools.keyPersonRating.component').then(
            (m) => m.ResearchToolsKeyPersonRatingComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/tools/legacy-research',
        loadComponent: () =>
          import('./components/research/tools/research-tools.legacyResearch.component').then((m) => m.ResearchToolsLegacyResearchComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/tools/insurer-selection-screen',
        loadComponent: () =>
          import('./components/research/tools/research-tools.insurerSelectionScreen.component').then(
            (m) => m.ResearchToolsInsurerSelectionScreenComponent
          ),
      },
      {
        path: 'research/tools/adviser-claims-experience',
        loadComponent: () =>
          import('./components/research/tools/adviser-claims-experience/ace-list/ace-list.component').then((m) => m.ACEListComponent),
      },
      {
        path: 'research/tools/adviser-claims-experience-details/create',
        loadComponent: () =>
          import('./components/research/tools/adviser-claims-experience/ace-details/ace-details.component').then(
            (m) => m.ACEDetailsComponent
          ),
      },
      {
        path: 'research/tools/adviser-claims-experience-details/:aceId',
        loadComponent: () =>
          import('./components/research/tools/adviser-claims-experience/ace-details/ace-details.component').then(
            (m) => m.ACEDetailsComponent
          ),
      },
      {
        path: 'research/tools/adviser-claims-experience-comments/:aceId',
        loadComponent: () =>
          import('./components/research/tools/adviser-claims-experience/ace-comments/ace-comments.component').then(
            (m) => m.ACECommentsComponent
          ),
      },
      {
        path: 'research/tools/standalone-head-to-head',
        loadComponent: () =>
          import('./components/research/tools/standalone-head-to-head/standalone-head-to-head.component').then(
            (m) => m.StandaloneHeadToHeadComponent
          ),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/policy/wording',
        loadComponent: () =>
          import('./components/research/policy/research-policy-wording.component').then((m) => m.ResearchPolicyWordingComponent),
        canActivate: [QmAuthGuard],
      },
      {
        path: 'research/policy/document',
        loadComponent: () =>
          import('./components/research/policy/research-policy-document.component').then((m) => m.ResearchPolicyDocumentComponent),
      },

      // subscription
      {
        path: 'research/subscription/plan',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription.component').then((m) => m.ResearchSubscriptionComponent),
      },
      {
        path: 'research/subscription/payments',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-payments.component').then(
            (m) => m.ResearchSubscriptionPaymentsComponent
          ),
      },
      {
        path: 'research/subscription/billing-address',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-billing-address').then(
            (m) => m.ResearchSubscriptionBillingAddressComponent
          ),
      },
      {
        path: 'research/subscription/invoices',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-invoices.component').then(
            (m) => m.ResearchSubscriptionInvoicesComponent
          ),
      },
      {
        path: 'research/subscription/terms',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-terms.component').then(
            (m) => m.ResearchSubscriptionTermsComponent
          ),
      },
      {
        path: 'research/subscription/existing-licenses',
        loadComponent: () =>
          import('./components/research/subscription/research-subscription-existing-licenses.component').then(
            (m) => m.ResearchSubscriptionExistingLicensesComponent
          ),
      },
      {
        path: 'research/subscription/order/:licensesId',
        loadComponent: () =>
          import('./components/research/subscription/research-license-order.component').then((m) => m.ResearchLicenseOrderComponent),
      },
      {
        path: 'research/subscription/payment-select/:stamp',
        loadComponent: () =>
          import('./components/research/subscription/research-license-orderPaymentSelect.component').then(
            (m) => m.ResearchLicenseOrderPaymentSelectComponent
          ),
      },
      // fact finds
      {
        path: 'fact-find/dashboard',
        loadComponent: () =>
          import('./components/fact-find/fact-find-dashboard/fact-find-dashboard.component').then((m) => m.FactFindDashboardComponent),
        canActivate: [AmAuthGuard],
      },
      {
        path: 'fact-find/details',
        loadComponent: () =>
          import('./components/fact-find/fact-find-details/fact-find-details.component').then((m) => m.FactFindDetailsComponent),
        canDeactivate: [CanDeactivateGuard],
        canActivate: [AmAuthGuard],
      },
      // business insurance
      {
        path: 'business/dashboard',
        loadComponent: () =>
          import('./components/business/dashboard/business-dashboard.component').then((m) => m.BusinessDashboardComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/detail',
        loadComponent: () => import('./components/business/detail/business-detail.component').then((m) => m.BusinessDetailComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/people',
        loadComponent: () => import('./components/business/people/people.component').then((m) => m.BusinessPeopleComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/financial-position',
        loadComponent: () =>
          import('./components/business/financial-position/financial-position.component').then((m) => m.BusinessFinancialPositionComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/financial-performance',
        loadComponent: () =>
          import('./components/business/financial-performance/financial-performance.component').then(
            (m) => m.BusinessFinancialPerformanceComponent
          ),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/existing-covers',
        loadComponent: () =>
          import('./components/business/existing-covers/bus-existing-covers.component').then((m) => m.BusinessExistingCoverComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/nature',
        loadComponent: () => import('./components/business/nature/bus-nc-nature.component').then((m) => m.BusinessNcNatureComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/objectives',
        loadComponent: () =>
          import('./components/business/objectives/bus-nc-objectives.component').then((m) => m.BusinessNcObjectivesComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/scope-priorities',
        loadComponent: () =>
          import('./components/business/scope-and-priorities/bus-nc-scope-priorities.component').then(
            (m) => m.BusinessNcScopePrioritiesComponent
          ),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/nc/calculations',
        loadComponent: () =>
          import('./components/business/nc-calculations/bus-nc-calculations.component').then((m) => m.BusinessNcCalculationsComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/quote/people-benefit-detail',
        loadComponent: () =>
          import('./components/business/quote/benefit/bus-quote-benefit.component').then((m) => m.BusinessQuoteBenefitDetailComponent),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/quote/research',
        loadComponent: () =>
          import('./components/business/quote/research/business-quote-research-index.component').then(
            (m) => m.BusinessQuoteResearchIndexComponent
          ),
        canActivate: [BmAuthGuard],
      },
      {
        path: 'business/quote/report',
        loadComponent: () =>
          import('./components/business/quote/report/business-quote-report.component').then((m) => m.BusinessQuoteReportComponent),
        canActivate: [BmAuthGuard],
      },
      // kiwiMonster
      {
        path: 'kiwimonster/dashboard',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-dashboard.component').then((m) => m.KiwiMonsterDashboardComponent),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/quote/client',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-client/kiwimonster-client.component').then((m) => m.KiwiMonsterClientComponent),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/quote/kiwisaver',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-kiwisaver/kiwimonster-kiwisaver.component').then(
            (m) => m.KiwiMonsterKiwiSaverComponent
          ),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/quote/compare',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-compare/kiwimonster-compare.component').then((m) => m.KiwiMonsterCompareComponent),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/quote/report',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-report/kiwimonster-report.component').then((m) => m.KiwiMonsterReportComponent),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/faq',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-faq/kiwimonster-faq.component').then((m) => m.KiwiMonsterFaqComponent),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/how-it-works',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-how-it-works/kiwimonster-how-it-works.component').then(
            (m) => m.KiwiMonsterHowItWorksComponent
          ),
        canActivate: [KmAccessDeniedGuard],
      },
      {
        path: 'kiwimonster/setting/preferred-funds',
        loadComponent: () =>
          import('./components/setting/kiwimonster/kiwimonster-preferred-funds/kiwimonster-preferred-funds.component').then(
            (m) => m.KiwiMonsterPreferredFundsComponent
          ),
        canActivate: [KmAccessDeniedGuard, KmAuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'kiwimonster/setting/research-factor',
        loadComponent: () =>
          import('./components/setting/kiwimonster/kiwimonster-factor-settings/kiwimonster-factor-settings.component').then(
            (m) => m.KiwiMonsterFactorSettingsComponent
          ),
        canActivate: [KmAccessDeniedGuard, KmAuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'kiwimonster/setting/scheme-settings',
        loadComponent: () =>
          import('./components/setting/kiwimonster/kiwimonster-scheme-settings/kiwimonster-scheme-settings.component').then(
            (m) => m.KiwiMonsterSchemeSettingsComponent
          ),
        canActivate: [KmAccessDeniedGuard, KmAuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'kiwimonster/setting/soa',
        loadComponent: () =>
          import('./components/setting/kiwimonster/kiwimonster-soa/kiwimonster-soa.component').then((m) => m.KiwiMonsterSoaComponent),
        canActivate: [KmAccessDeniedGuard, KmAuthGuard],
      },
      {
        path: 'public/book-training-claim-free-trial',
        loadComponent: () =>
          import('./components/about/book-training-claim-trial.component').then((m) => m.BookTrainingClaimTrialComponent),
      },
      {
        path: 'kiwimonster/nc/:stepName',
        loadComponent: () =>
          import('./components/kiwimonster/kiwimonster-need-analysis/kiwimonster-nc.component').then((m) => m.KiwiMonsterNcComponent),
        canActivate: [KmAccessDeniedGuard],
      },
    ],
  },

  // all other
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
